import type {
  SeasonalEvent,
  SeasonalEventOccurrence,
} from "~/integrations/firebase/collections/seasonal-events";
import {
  displayWindowEnd,
  getLeadTimeDays,
} from "~/components/seasonal-events/calendar-utils";

const HOME_EVENT_CARD_COUNT = 3;

export interface HomeSeasonalEvent {
  event: SeasonalEvent;
  occurrence: SeasonalEventOccurrence;
  leadTimeDays: number;
}

const nextUnstartedOccurrence = (
  event: SeasonalEvent,
  today: string,
): SeasonalEventOccurrence | undefined =>
  event.occurrences
    .filter((occurrence) => occurrence.start >= today)
    .sort((a, b) => a.start.localeCompare(b.start))[0];

// Home drops an event once it starts; its lead-in window does not gate it.
export const getHomeSeasonalEvents = (
  events: SeasonalEvent[],
  today: string,
): HomeSeasonalEvent[] =>
  events
    .flatMap((event) => {
      const occurrence = nextUnstartedOccurrence(event, today);
      if (!occurrence || occurrence.start > displayWindowEnd(today)) {
        return [];
      }
      return [
        {
          event,
          occurrence,
          leadTimeDays: getLeadTimeDays(occurrence.start, today),
        },
      ];
    })
    .sort(
      (a, b) =>
        a.occurrence.start.localeCompare(b.occurrence.start) ||
        a.event.display_name.localeCompare(b.event.display_name),
    )
    .slice(0, HOME_EVENT_CARD_COUNT);
